import { create } from "zustand";

type CartState = {
  isDrawerOpen: boolean;
  actions: {
    openDrawer: () => void;
    closeDrawer: () => void;
  };
};

const useCartStore = create<CartState>()((set, get) => ({
  isDrawerOpen: false,
  actions: {
    openDrawer: () => set({ isDrawerOpen: true }),
    closeDrawer: () => set({ isDrawerOpen: false }),
  },
}));

export const useCartDrawerIsOpen = () => useCartStore((x) => x.isDrawerOpen);
export const useCartUiActions = () => useCartStore((x) => x.actions);
